import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { music24PlanCapabilities } from 'fym-shared/src/music24/music24Plans';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { SMLUpgradeFeature } from '../../config/music24PlanCapabilities';
import { useUpgradePrompt } from '../../hooks/useUpgradePrompt';
import { outreachMessages as messages } from '../outreachMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface OutreachPlanCardProps {
  /** The headline: "142 playlists add songs like Low Tide". Default: the plain headline. */
  title?: string;
  /** The song the prompt names ("Pitch Low Tide to curators"). */
  subject?: string;
}

/**
 * The card of Free (design outreach a4): find and draft yes, send no. "See plans" opens the plan
 * prompt with the plans that pitch every day, cheapest first.
 */
const OutreachPlanCardComponent: React.FC<OutreachPlanCardProps> = ({ title, subject }) => {
  const intl = useIntl();
  const openUpgradePrompt = useUpgradePrompt();
  const open = useCallback(() => openUpgradePrompt(SMLUpgradeFeature.outreach, subject), [openUpgradePrompt, subject]);

  return (
    <div className={styles.planCard} data-testid="outreach-plan-card">
      <span className={styles.planIcon}>
        <FontAwesomeIcon icon={faLock} />
      </span>
      <div className={styles.planText}>
        <b>{title ?? intl.formatMessage(messages.freeTitle)}</b>
        <p>
          {intl.formatMessage(messages.freeBody, {
            artist: music24PlanCapabilities.artist.outreachPitchesPerDay,
            pro: music24PlanCapabilities.pro.outreachPitchesPerDay,
            label: music24PlanCapabilities.label.outreachPitchesPerDay,
          })}
        </p>
      </div>
      <div className={styles.row}>
        <span className={`${styles.chip} ${styles.chipMuted}`}>{intl.formatMessage(messages.lockedOnPaid)}</span>
        <SMLButton color="primary" size="sm" omitCap onClick={open}>
          {intl.formatMessage(messages.seePlans)}
        </SMLButton>
      </div>
    </div>
  );
};

export const OutreachPlanCard = TypedMemo(OutreachPlanCardComponent);
